import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import clsx from 'clsx';
import { makeStyles, Typography } from '@vitessce/styles';
import { colorArrayToString } from '@vitessce/sets-utils';
const useStyles = makeStyles()(() => ({
    channelNamesLegendContainer: {
        position: 'absolute',
        bottom: '0px',
        left: '0px',
        paddingLeft: '10px',
        paddingBottom: '10px',
    },
    channelNamesLegendLayer: {
        display: 'flex',
    },
    channelNamesRow: {
        flexDirection: 'column',
    },
    channelNamesCol: {
        flexDirection: 'row',
    },
    channelNameText: {
        marginRight: '10px',
    },
}));
export default function ChannelNamesLegend(props) {
    const { images, imageLayerScopes, imageLayerCoordination, imageChannelScopesByLayer, imageChannelCoordination, } = props;
    const { classes } = useStyles();
    const reversedImageLayerScopes = useMemo(() => ([...(imageLayerScopes || [])].reverse()), [imageLayerScopes]);
    return (_jsx("div", { className: classes.channelNamesLegendContainer, children: imageLayerScopes ? reversedImageLayerScopes.map((layerScope) => {
            const layerCoordination = imageLayerCoordination[0][layerScope];
            const channelScopes = imageChannelScopesByLayer[layerScope];
            const channelCoordination = imageChannelCoordination[0][layerScope];
            const { spatialLayerVisible, photometricInterpretation, spatialChannelLabelsVisible, spatialChannelLabelsOrientation, spatialChannelLabelSize, spatialLayerColormap, } = layerCoordination;
            const isHorizontal = spatialChannelLabelsOrientation === 'horizontal';
            return ((photometricInterpretation !== 'RGB'
                && spatialLayerColormap === null
                && channelCoordination
                && channelScopes) ? (_jsx("div", { className: clsx(classes.channelNamesLegendLayer, {
                    [classes.channelNamesCol]: isHorizontal,
                    [classes.channelNamesRow]: !isHorizontal,
                }), children: channelScopes.map((cScope) => {
                    const { spatialTargetC, spatialChannelVisible, spatialChannelColor, } = channelCoordination[cScope];
                    const rgbColor = colorArrayToString(spatialChannelColor);
                    const imageWrapperInstance = images?.[layerScope]?.image?.instance;
                    const channelNames = imageWrapperInstance?.getChannelNames();
                    const channelIndex = imageWrapperInstance?.getChannelIndex(spatialTargetC);
                    const channelName = channelIndex !== undefined
                        ? channelNames?.[channelIndex]
                        : undefined;
                    return spatialLayerVisible && spatialChannelVisible && spatialChannelLabelsVisible ? (_jsx(Typography, { variant: "h6", className: classes.channelNameText, style: {
                            color: rgbColor,
                            fontSize: `${spatialChannelLabelSize}px`,
                        }, children: channelName }, `${layerScope}-${cScope}-${channelIndex}-${rgbColor}`)) : null;
                }) }, layerScope)) : null);
        }) : null }));
}
//# sourceMappingURL=ChannelNamesLegend.js.map